/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { IrrApiVersionEnum } from './irrApiVersionEnum';
import { VcdsServiceTypeEnum } from './vcdsServiceTypeEnum';


export interface DeploymentRegionUnlinkSpec { 
    service_type: ServiceTypeEnum;
    vcds_service_type: VcdsServiceTypeEnum;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * IP address of gateway
     */
    gateway_ip: string;
    /**
     * FQDN of gateway to unlink and delete DNS entry
     */
    gateway_fqdn?: string;
    irr_api_version?: IrrApiVersionEnum;
    /**
     * Version of IRR. If specified, version will not be polled from EC2 instance. If skip_org_ip_validation is enabled, this value will be ignored.
     */
    irr_version?: string;
    /**
     * If enabled it will skip errors at each step and proceed for next (unregister service, DNS record and OAuth app deletion)
     */
    force_unlink?: boolean;
    /**
     * Should the FQDN scheme be old style (vcdr-35-165-175-28.staging.app.vcdr.vmware.com) or new (35-165-175-28-us-west-2.console.ds-stg.vmware.com). Also the IRR API version old vs new.This applies only for VCDR service type.
     */
    old_scheme?: boolean;
    /**
     * Operator can skip several level of org and Ip address validation to be less strict.
     */
    skip_org_ip_validation?: boolean;
}
export namespace DeploymentRegionUnlinkSpec {
}


